<template>
  <div v-if="filters.length > 0" class="filters-info">
    <v-subheader>
      {{ lang.historic.filters.title }}
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            small
            @click.stop="clearFilters()"
            class="mr-2 clear-btn"
            color="gray darken-2"
          >
            <v-icon small>mdi-broom</v-icon>
          </v-btn>
        </template>
        <span>{{ lang.historic.filters.clear }}</span>
      </v-tooltip>
    </v-subheader>
    <v-row
      v-for="(filter, i) in filters"
      :key="i"
      class="filter"
    >
      <v-col cols="5" class="filter-label">
        {{ filter.label }}
      </v-col>
      <v-col cols="7" class="filter-text">
        <p v-if="!Array.isArray(filter.text)">{{ filter.text }}</p>
        <template v-else>
          <p
            v-for="(value, i_) in filter.text"
            :key="`val-${i_}`"
          >
            {{ value }}
          </p>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import defaults from '@/mixins/defaults/filters'

export default {
  mixins: [ appdata, utils ],
  computed: {
    filters () {
      let filters = (this.get_global.filters.orders && this.get_global.filters.orders.data ? { ...this.get_global.filters.orders.data } : false)
      let filters_ = []
      Object.keys(filters).forEach((key) => {
        let value = filters[key]
        let label = false
        let text = false
        switch (key) {
          case 'date': {
            label = this.lang.historic.filters.date_range.date
            text = (value.length === 2 && (value[0] && value[0] !== '0000-00-00' && value[1] && value[1] !== '0000-00-00') ? `${this.formatDate(value[0], false)} ~ ${this.formatDate(value[1], false)}` : false)
            break
          }
          case 'type': {
            label = this.lang.historic.filters.type.title
            let types = (value > 0 ? this.get_global.defaults.options.orders.types : false)
            let type = (types ? types.find((el) => el.id === value) : false)
            text = (type ? type.title : false)
            break
          }
          case 'payment': {
            label = this.lang.historic.filters.payment.title
            let payments = (value > 0 ? this.get_global.defaults.options.orders.paid : false)
            let payment = (payments ? payments.find((el) => el.id === (value - 1)) : false)
            text = (payment ? payment.title : false)
            break
          }
          case 'status': {
            label = this.lang.historic.filters.status.title
            if (value.length > 0) {
              let status = (this.get_global.defaults.options.orders ? this.get_global.defaults.options.orders.status : false)
              text = value.map(function (value) {
                let status_ = status.find((el) => el.value === value)
                return (status_ ? status_.text : value)
              })
            }
            break
          }
          case 'customers': {
            label = this.lang.historic.filters.customers.title
            if (value.length > 0) {
              let customers = (this.get_data ? this.get_data.customers : false)
              text = value.map(function (id) {
                let customer = customers.find((el) => el.id === id)
                return (customer ? `#${customer.id} ${customer.name}` : id)
              })
            }
            break
          }
          case 'addresses': {
            label = this.lang.historic.filters.addresses.title
            text = (value.length > 0 ? value.map((address) => address.cep) : false)
            break
          }
          case 'order_list': {
            label = this.lang.historic.filters.order.title
            if (value.length > 0 && filters.order_op > 0) {
              let items = (this.get_data ? this.get_data.catalog : false)
              let opOptions = (this.get_global.defaults.options.historic.filters.order ? this.get_global.defaults.options.historic.filters.order.operation : false)
              let operation = [(opOptions.find((el) => el.id === filters.order_op) || {}).title]
              text = operation.concat(value.map(function (id) {
                let item = items.find((el) => el.id === id)
                return (item ? `#${item.id} ${item.title}` : id)
              }))
            }
            break
          }
          case 'categories': {
            label = this.lang.historic.filters.categories.title
            if (value.length > 0 && filters.order_op === 0) {
              let categories = (this.get_data ? this.get_data.categories : false)
              text = value.map(function (id) {
                let categorie = categories.find((el) => el.id === id)
                let parent = (categorie && categorie.parent > 0 ? categories.find((el) => el.id === categorie.parent) : false)
                return (categorie ? `${(parent ? parent.name + ' > ' : '')}${categorie.name}` : id)
              })
            }
            break
          }
        }
        if (label && text) filters_.push({ label, text })
      })
      return filters_
    }
  },
  watch: {
    '$store.state.global.filters.orders.data': {
      deep: true,
      handler () {
        this.$forceUpdate()
      }
    }
  },
  methods: {
    clearFilters () {
      this.$store.dispatch('setGlobalFilters', Object.assign({}, { orders: { ...defaults.orders } }))
      this.$store.dispatch('socket/CUSTOM_DATA', this.get_global.filters)
    }
  }
}
</script>
